import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26b35bc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "coordinator-port-input" }
const _hoisted_2 = {
  key: 0,
  class: "gordita-400-11 ib-color-red"
}
const _hoisted_3 = {
  key: 0,
  class: "settings-incredi-input-icon"
}
const _hoisted_4 = ["data-testid"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "incredi-input-number-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _directive_incredi_input_num_type = _resolveDirective("incredi-input-num-type")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_q_input, _mergeProps({
      modelValue: _ctx.port,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.port) = $event)),
      modelModifiers: { number: true },
      type: "number",
      "no-error-icon": "",
      class: ["incredi-input new-width incredi-input-hidenumbers hover-shadow ibf-text-list3", { disabled: _ctx.$attrs.disable, 'not-valid': _ctx.isPortValid === false, valid: _ctx.isPortValid !== false }],
      min: "0",
      outlined: "",
      for: _ctx.inputFor
    }, _ctx.$attrs, {
      error: _ctx.isPortValid === false,
      "bottom-slots": ""
    }), {
      error: _withCtx(() => [
        (_ctx.isPortValid === false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true)
      ]),
      loading: _withCtx(() => []),
      append: _withCtx(() => [
        (_ctx.loading || _ctx.isPortValid !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_q_spinner, {
                    key: 0,
                    color: "primary",
                    size: "16px",
                    "data-testid": _ctx.elementIds.settings.form.windows.general.settingsPortInput.validationLoader
                  }, null, 8, ["data-testid"]))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    "data-testid": _ctx.isPortValid ? _ctx.elementIds.settings.form.windows.general.settingsPortInput.isValidIcon : _ctx.elementIds.settings.form.windows.general.settingsPortInput.isErrorIcon,
                    class: _normalizeClass({
              ['icon-Approval-normal']: _ctx.isPortValid,
              ['icon-Approval-error']: !_ctx.isPortValid,
            })
                  }, _hoisted_7, 10, _hoisted_4))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_q_btn, {
            "data-testid": _ctx.elementIds.settings.form.windows.general.settingsPortInput.arrowUp,
            padding: "none",
            size: "xs",
            ripple: false,
            square: "",
            dense: "",
            flat: "",
            icon: "keyboard_arrow_up",
            class: "incredi-input-number-box-btn incredi-input-number-box-btn-up",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.port = +_ctx.port + 1))
          }, null, 8, ["data-testid"]),
          _createVNode(_component_q_btn, {
            "data-testid": _ctx.elementIds.settings.form.windows.general.settingsPortInput.arrowDown,
            padding: "none",
            size: "xs",
            ripple: false,
            square: "",
            dense: "",
            flat: "",
            icon: "keyboard_arrow_down",
            class: "incredi-input-number-box-btn incredi-input-number-box-btn-down",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.port = +_ctx.port - 1))
          }, null, 8, ["data-testid"])
        ])
      ]),
      _: 1
    }, 16, ["modelValue", "class", "for", "error"])), [
      [_directive_incredi_input_num_type]
    ])
  ]))
}